import { Alert, AlertTitle } from "@mui/lab";
import { Box, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { sendClientTelemetry } from "../telemetry/clientTelemetry";
import { AuthContext } from "./AuthProvider";

export function Logout() {
	const { clearUserData } = useContext(AuthContext);
	const navigate = useNavigate();
	const [params, setParams] = useSearchParams();
	const [message, setMessage] = useState<string>("");

	const logout = () => {
		sendClientTelemetry({ eventType: "logout", keepalive: true });

		// Clear any auto-logout data from localStorage
		localStorage.removeItem("shiftAutoLogout");

		clearUserData();

		// Check if there's a message parameter
		const messageParam = params.get("message");
		if (messageParam) {
			// Remove message from params before redirecting
			const newParams = new URLSearchParams(params);
			newParams.delete("message");
			navigate(`/?${newParams.toString()}`);
		} else {
			navigate(`/?${params.toString()}`);
		}
	};

	useEffect(() => {
		// Check for message parameter
		const messageParam = params.get("message");
		if (messageParam) {
			setMessage(decodeURIComponent(messageParam));
		}

		// Perform logout after a brief delay to show the message
		const timer = setTimeout(
			() => {
				logout();
			},
			message ? 2000 : 0,
		);

		return () => clearTimeout(timer);
	}, []);

	return (
		<React.Fragment>
			<Box
				display="flex"
				flexDirection="column"
				alignItems="center"
				justifyContent="center"
				minHeight="100vh"
			>
				{message && (
					<Alert severity="info" style={{ marginBottom: 20 }}>
						<AlertTitle>Session Ended</AlertTitle>
						<Typography>{message}</Typography>
					</Alert>
				)}
				<Typography variant="h6">Logging out...</Typography>
			</Box>
		</React.Fragment>
	);
}
